import FetchWrapper from '../Common/Wrappers/FetchWrapper';
import { Service } from '../Common/service.enum';
import Logging from '../../Logging/Logging';
import {
  filtersToStandardQueryParams,
  sortModelToStandardQueryParam,
} from '../Common/filterSorting';
import {
  AuditReportCollection,
  AuditReport,
  CertificateReportCollection,
  CertificateReport,
  ErrorLogCollection,
  ExemptionType,
  Jurisdiction,
} from '../../..';

export default class CertificateRepo {
  private fetch: FetchWrapper;

  constructor(fetch: FetchWrapper) {
    this.fetch = fetch;
  }

  getCertificateReportsV41(
    startRow: number,
    endRow: number,
    filterModel: string[] = null,
    sortModel: string[] = null,
  ): Promise<CertificateReportCollection> {
    const apiServiceEndpoint = 'portal/v4.1/reports/certificate';
    const filterQueryParams = filtersToStandardQueryParams(filterModel);
    const sortQueryParam = sortModelToStandardQueryParam(sortModel);
    const numberRows = endRow > startRow ? endRow - startRow : 0;
    const pagingQueryParam = `&$top=${numberRows}&$skip=${startRow}&$count=true`;

    let queryParams = '';
    if (filterQueryParams && sortQueryParam) {
      queryParams = `?${filterQueryParams}&${sortQueryParam}`;
    } else if (filterQueryParams) {
      queryParams = `?${filterQueryParams}`;
    } else if (sortQueryParam) {
      queryParams = `?${sortQueryParam}`;
    }

    // Add the Paging Parameters
    if (pagingQueryParam) {
      queryParams += queryParams === '' ? `?${pagingQueryParam}` : pagingQueryParam;
    }

    const url = `${apiServiceEndpoint}${queryParams}`;

    Logging.Info('GET', url);
    return this.fetch.getFromService<CertificateReportCollection>(Service.ECM, url);
  }

  addCertificateReportV41(certificateReport: CertificateReport): Promise<void> {
    const apiServiceEndpoint = 'portal/v4.1/reports/certificate';

    const queryParams = '';
    const url = `${apiServiceEndpoint}${queryParams}`;

    Logging.Info('POST', url, certificateReport);
    return this.fetch.postToService<void>(Service.ECM, url, certificateReport);
  }

  getAuditReportsV41(
    startRow: number,
    endRow: number,
    filterModel: string[] = null,
    sortModel: string[] = null,
  ): Promise<AuditReportCollection> {
    const apiServiceEndpoint = 'portal/v4.1/reports/audit';
    const filterQueryParams = filtersToStandardQueryParams(filterModel);
    const sortQueryParam = sortModelToStandardQueryParam(sortModel);
    const numberRows = endRow > startRow ? endRow - startRow : 0;
    const pagingQueryParam = `&$top=${numberRows}&$skip=${startRow}&$count=true`;

    let queryParams = '';
    if (filterQueryParams && sortQueryParam) {
      queryParams = `?${filterQueryParams}&${sortQueryParam}`;
    } else if (filterQueryParams) {
      queryParams = `?${filterQueryParams}`;
    } else if (sortQueryParam) {
      queryParams = `?${sortQueryParam}`;
    }

    // Add the Paging Parameters
    if (pagingQueryParam) {
      queryParams += queryParams === '' ? `?${pagingQueryParam}` : pagingQueryParam;
    }

    const url = `${apiServiceEndpoint}${queryParams}`;

    Logging.Info('GET', url);
    return this.fetch.getFromService<AuditReportCollection>(Service.ECM, url);
  }

  addAuditReportV41(auditReport: AuditReport): Promise<void> {
    const apiServiceEndpoint = 'portal/v4.1/reports/audit';

    const queryParams = '';
    const url = `${apiServiceEndpoint}${queryParams}`;

    Logging.Info('POST', url, auditReport);
    return this.fetch.postToService<void>(Service.ECM, url, auditReport);
  }

  getJurisdictionsV41(): Promise<Jurisdiction[]> {
    const apiServiceEndpoint = 'portal/v4.1/jurisdictions';

    const queryParams = '';
    const url = `${apiServiceEndpoint}${queryParams}`;

    Logging.Info('GET', url);
    return this.fetch.getFromService<Jurisdiction[]>(Service.ECM, url);
  }

  getExemptionsV41(): Promise<ExemptionType[]> {
    const apiServiceEndpoint = 'portal/v4.1/exemptions';

    const queryParams = '';
    const url = `${apiServiceEndpoint}${queryParams}`;

    Logging.Info('GET', url);
    return this.fetch.getFromService<ExemptionType[]>(Service.ECM, url);
  }

  getErrorLogsV41(
    startRow: number,
    endRow: number,
    filterModel: string[] = null,
    sortModel: string[] = null,
  ): Promise<ErrorLogCollection> {
    const apiServiceEndpoint = 'portal/v4.1/sync/logs';
    const filterQueryParams = filtersToStandardQueryParams(filterModel);
    const sortQueryParam = sortModelToStandardQueryParam(sortModel);
    const numberRows = endRow > startRow ? endRow - startRow : 0;
    const pagingQueryParam = `&$top=${numberRows}&$skip=${startRow}&$count=true`;

    let queryParams = '';
    if (filterQueryParams && sortQueryParam) {
      queryParams = `?${filterQueryParams}&${sortQueryParam}`;
    } else if (filterQueryParams) {
      queryParams = `?${filterQueryParams}`;
    } else if (sortQueryParam) {
      queryParams = `?${sortQueryParam}`;
    }

    // Add the Paging Parameters
    if (pagingQueryParam) {
      queryParams += queryParams === '' ? `?${pagingQueryParam}` : pagingQueryParam;
    }

    const url = `${apiServiceEndpoint}${queryParams}`;

    Logging.Info('GET', url);
    return this.fetch.getFromService<ErrorLogCollection>(Service.ECM, url);
  }

  deleteErrorLogV41(id: number): Promise<void> {
    const apiServiceEndpoint = `portal/v4.1/sync/logs/${id}`; // FIX ME

    const queryParams = '';
    const url = `${apiServiceEndpoint}${queryParams}`;

    Logging.Info('DELETE', url);
    return this.fetch.delFromService<void>(Service.ECM, url);
  }
}
